import * as React from 'react';
import type { ReactNode } from 'react';

export function DetailSection({ title, children }: { title?: string; children: ReactNode }) {
  const titleId = React.useId();

  return (
    <>
      {title ? (
        <p
          id={titleId}
          className="col-span-2 text-xs font-medium uppercase tracking-wide text-muted-foreground not-first:mt-2"
        >
          {title}
        </p>
      ) : null}
      <dl className="contents" aria-labelledby={title ? titleId : undefined}>
        {children}
      </dl>
    </>
  );
}
